import { ref, onMounted, onBeforeUnmount } from 'vue';
import { getBootstrapData } from '@experience/core-hostapp-share-lib';

interface UseLazySectionOptions {
  rootMargin?: string;
  threshold?: number;
}

export function useLazySection(options: UseLazySectionOptions) {
  const { rootMargin = '200px', threshold = 0.25 } = options;

  const targetRef = ref<HTMLElement | null>(null);
  const isVisible = ref(getBootstrapData().prerenderMode);
  let observer: IntersectionObserver | null = null;

  const startObserving = () => {
    if (!targetRef.value) {
      return;
    }

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            isVisible.value = true;
            if (observer && targetRef.value) {
              observer.unobserve(targetRef.value);
            }
          }
        });
      },
      {
        rootMargin,
        threshold,
      },
    );

    observer.observe(targetRef.value);
  };

  onMounted(() => {
    startObserving();
  });

  onBeforeUnmount(() => {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  });

  return {
    targetRef,
    isVisible,
  };
}
